import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs';

function SteelIndustry() {
//   const page = "steelindustry";
  const page = "industry";
  return (
    <div>
        <section className={`hero ${page}`}>
            <h1>Steel & Foundries</h1>
        </section>

        <Breadcrumbs
            items={[
                { label: "Home", to: "/" },
                { label: "Solutions", to: "/solutions" },
                { label: "Steel-Industry" }, // no `to` = current page
        ]}
        />

        <section class="split-about">
        <div class="split-about__wrap">
            <div class="split-about__content">
            <p>
                The steel and foundry industries are essential to global manufacturing, providing critical raw materials for construction, automotive, and 
                industrial sectors. Operations in these industries take place in high-temperature, high-stress environments that demand durable, reliable, and 
                performance-tested materials. Efficiency and safety are paramount, as downtime or quality issues can lead to significant financial losses.
            </p>
            </div>


            <figure class="split-about__media">
            <img src="/assets/images/industry/steel-industry.png" alt="Application film rolls" />
            </figure>

        </div>
        </section>

        <section class="applications">
        <div class="applications__wrap">
            <h1>Our Solutions:</h1>

            <ul class="applications__list">
            <li><strong>High-Temperature Additives & Binders</strong>: Enhance performance in smelting and casting.</li>
            <li><strong>Furnace Durability</strong>: Improve furnace efficiency and extend operational lifespan.</li>
            <li><strong>Process Stability</strong>: Reduce downtime and ensure consistent product quality.</li>
            </ul>

            <p>
            </p>
        </div>
        </section>
    </div>
  )
}

export default SteelIndustry